import {Layout} from "./Layout.js";
import {getUserId} from "../../store.js";


export class AppSumoLayout extends Layout {
	template() {
		const {sectionId = '', userId = ""} = this.$props;
		return `
                <section id="${sectionId}" class="signup-wide-pop btn-bottom-case">
                    <header class="js-section-header"></header>
                    <article>
                        <div class="pop-main js-contents-main">
                            ${this.getMainTextTemplate()}
                            ${this.getSubTextTemplate()}
                            <ul>
                             	${this.getUserEmailInputTemplate()}
                             	<li id ="companyNameLayer"></li>
                                <li id ="userNameLayer"></li>
                                <li id ="passwordLayer"></li>
                              </ul>
                              <div class="bottom-button-wrap">
                                 ${this.getNexPageButtonTemplate()}
                              </div>
                        </div>
                    </article>
                </section>`
	}

	getCompanyNameLayer() {
		return $("#companyNameLayer");
	}

	getSubDomainInputLayer() {
		return $("#subDomainInputLayer");
	}

	getUserNameLayer() {
		return $("#userNameLayer");
	}

	getPasswordLayer() {
		return $("#passwordLayer");
	}


	getUserEmailInputTemplate() {
		const userId = getUserId();
		return `<li>
                   <div class="interactive-form-wrap js-interactive-form-wrap">
                   		<input class="js-name-input join-name-input interactive-form-input js-join-input" placeholder="${userId}" value="${userId}" disabled>
                   </div>
                 </li>`
	}

	getNexPageButtonTemplate() {
		const {nextButton = {}} = this.$props;
		return `<button id = "${nextButton.id}" class="js-next-page-button button-sign-next" tabindex="4" >Get Started</button>`;
	}
}
